<div class="d-none d-md-block" *ngIf="cardTypeData === 'CALCULATOR'">
  <div class="d-flex justify-content-between mt-2" style="padding: 4px 23px;">
    <div class="cardAdd">Fund Performance</div>
    <div type="button" data-bs-dismiss="offcanvas" aria-label="Close"><img
        src="./assets/images/comparefund/Frame 1000007569.png"></div>
  </div>
</div>
<div class="container FT-all-funds-Card" *ngIf="!addFundData">
  <div class="mb-4">
    {{ pageSubHeading }}
  </div>

  <div class="row align-items-center watchlist-box">
    <div class="col-lg-4 empty-cart-wraper">
      <div *ngIf="cardTypeData === 'EMPTY_WATCHLIST' ">
        <div class="empty-cart text-center" *ngIf="!CartSectionImg">
          <div style="width: 110px;height: auto; margin: 0 auto;">
            <img alt='Save' src="assets/images/watchlist/Save.svg" class="mb-4">
          </div>
          <h3 class="mb-md-4 mb-3">{{ "products.empty-page-add-funds-to-watchlist-heading" | translate }}</h3>
          <div>
            {{ "products.empty-page-add-funds-to-watchlist-Subheading" | translate }}
          </div>
        </div>
        <div class="empty-cart text-center" *ngIf="CartSectionImg">
          <div style="width: 170px;height: auto; margin: 0 auto;">
            <!-- <img alt="Cart" src="assets/images/cart/ShoppingCart.png" class="mb-4">-->
          </div>
          <h3 class="mb-md-4 mb-3">Your Cart is empty</h3>
          <div>
            Looks like you have not added anything to your Cart. Go ahead and explore our funds
          </div>
        </div>
      </div>
      <div class="empty-cart text-center" *ngIf="cardTypeData === 'EMPTY_COMPARE'">
        <div style="width: 170px;height: auto; margin: 0 auto;">
          <img alt="Cart" src="/assets/images/cart/Component533.svg" class="mb-4">
        </div>
        <h3 class="mb-md-4 mb-3">{{ "ftiGeneric.empty-page-add-funds-to-compare-heading" | translate }}</h3>
        <div>
          {{ "ftiGeneric.empty-page-add-funds-to-compare-Subheading" | translate }}
        </div>
      </div>
    </div>

    <div class="col-lg-8" *ngIf="fundData?.length">
      <div class="filter-options mt-0 mb-4">
        <div class="form-group ">
          <input type="text" class="form-control search"
                 placeholder="{{ 'products.compare-fund-search-placeholder' | translate }}"
                 [(ngModel)]="searchTerm" (input)="searchFunds(searchTerm)">
          <div class="search-result" *ngIf="showFundSearchDropdown && searchTerm && searchTerm.length >= 3">
            <div class="inner">
              <ng-container *ngFor="let fund of fundsForSearch">
                <div class="funds-seach-title" (click)="showSelectedFund(fund)"
                     style="position: relative; z-index: 999999; cursor: pointer;">
                  <b>{{ fund?.fundName }}</b>
                  <span class="sub">{{ removeFundString(fund?.assetClass) }}</span>
                  <span class="sub">{{ removeFundString(fund?.invfocus) }}</span>
                  <span class="sub">{{ fund?.fundInceptionDate | yearsOld }}</span>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <div>
          <img alt="Close" src="./assets/images/comparefund/closebutton.svg" class="make-tag-for-all-page share-icon2"
               (click)="clearSearch()">
        </div>
        <div class="dataFilter">
          <div class="d-flex align-items-center">
            <span class="me-2">{{ "products.all-funds-sort-by-btn" | translate }}</span>
            <div class="dropdown">
              <button class="btn dropdown-toggle cust-sort" type="button" data-bs-toggle="dropdown"
                      aria-expanded="false">
                <div class="has-filter-red-dot d-none"></div>
                <span class="sort-by-text">{{ selectedSortItem.label }}</span>
              </button>
              <ul class="dropdown-menu">
                <ng-container *ngFor="let item of sortItemsArray">
                  <li style="cursor: pointer;" (click)="sortFunds(item)"
                      [class.selected-option]="item.id === selectedSortItem.id">
                    <a class="dropdown-item">{{ item.label }}</a>
                  </li>
                </ng-container>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <ng-container *ngIf="fundListingData?.length && !addFundData">
        <div class="tab-head mb-4 forwatclistnavtab side-filter-options">
          <div class="scrollable-tabs">
            <ul class="nav nav-tabs" id="myTab-empty-page" role="tablist" style="margin-bottom: 3px;">
              <li class="nav-item" role="presentation" *ngFor="let element of sideFilterOptions; let i = index">
                <button class="nav-link"
                        [id]="element.name"
                        [ngClass]="{ 'active': element.name === activeButton }"
                        data-bs-toggle="pill"
                        data-bs-target="v-pills-all" type="button" role="tab"
                        [attr.aria-controls]="'v-pills-'+getMenuID(element.name, true)"
                        [attr.aria-selected]="{ true: i === 0 }"
                        [attr.data-tab-id]="'v-pills-'+getMenuID(element.name, true)"
                        (click)="showContentOnHover($event);setActiveButton(element.name)">{{ element.name }}
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div class="tab-content empty-page-card-list" id="v-pills-tabContent-empty-page"
             *ngIf="isLoaded && fundListingData?.length">
          <div class="tab-pane fade show active" id="v-pills-all" role="tabpanel"
               aria-labelledby="v-pills-all-tab" tabindex="0">
            <div class="funds-container" style="padding-top: 4px;">
              <ng-container *ngFor="let fundCard of fundListingData; let i = index;">
                <ft-home-fund-card [fund]="fundCard" [cardType]="cardTypeData" [brConfiguration]="brConfiguration"
                                   [hasThreeDotOptions]="hasThreeDotOptions? hasThreeDotOptions : false"></ft-home-fund-card>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
<ng-container *ngIf="addFundData">
  <ng-container *ngIf="isMobileAdd">
    <div class="FT-all-funds d-md-none" style="padding-top: 0; padding-bottom: 0;">
      <div class="filter-options mt-0 mb-4 filterFundsColorView">
        <div class="form-group">
          <input type="text" class="form-control search"
                 placeholder="{{ 'products.compare-fund-search-placeholder' | translate }}"
                 [(ngModel)]="searchTerm" (input)="searchFunds(searchTerm)">
          <div class="search-result" *ngIf="showFundSearchDropdown && searchTerm && searchTerm.length >= 3">
            <div class="inner">
              <ng-container *ngFor="let fund of fundsForSearch">
                <div class="funds-seach-title" (click)="showSelectedFund(fund)"
                     style="position: relative; z-index: 999999; cursor: pointer;">
                  <b>{{ fund?.fundName }}</b>
                  <span class="sub">{{ removeFundString(fund?.assetClass) }}</span>
                  <span class="sub">{{ removeFundString(fund?.invfocus) }}</span>
                  <span class="sub">{{ fund?.fundInceptionDate | yearsOld }}</span>
                </div>
              </ng-container>
            </div>
          </div>
          <div>
            <img class="share-icon2" alt="Close" src="./assets/images/comparefund/closebutton.svg"
                 style="position: relative; top: 16%; right: 162%;"
                 (click)="clearSearch()">
          </div>
          <div class="dataFilter">
            <div class="d-flex align-items-center">
              <div class="dropdown">
                <button class="btn dropdown-toggle" type="button" data-bs-toggle="dropdown"
                        aria-expanded="false">
                  <span class="me-2">{{ "products.all-funds-sort-by-btn" | translate }}</span>
                  <div class="has-filter-red-dot d-none"></div>
                  <span class="sort-by-text">{{ selectedSortItem.label }}</span>
                </button>
                <ul class="dropdown-menu">
                  <ng-container *ngFor="let item of sortItemsArray">
                    <li style="cursor: pointer;" (click)="sortFunds(item)"
                        [class.selected-option]="item.id === selectedSortItem.id">
                      <a class="dropdown-item">{{ item.label }}</a>
                    </li>
                  </ng-container>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tab-bar-container">
        <div class="All-tabBar d-md-none tab-head forwatclistnavtab side-filter-options" style="overflow: hidden;">
          <div class="scrollable-tabs tab-border-line">
            <ul class="nav nav-tabs pb-1" id="myTab" role="tablist">
              <li class="nav-item" role="presentation" *ngFor="let element of sideFilterOptions; let i = index">
                <button class="nav-link"
                        [id]="element.name"
                        [ngClass]="{ 'active': element.name === activeButton }"
                        data-bs-toggle="pill"
                        data-bs-target="#v-pills-all-add-fund" type="button" role="tab"
                        [attr.aria-controls]="'v-pills-'+getMenuID(element.name, true)"
                        [attr.aria-selected]="{ true: i === 0 }"
                        [attr.data-tab-id]="'v-pills-'+getMenuID(element.name, true)"
                        (click)="showContentOnHover($event);setActiveButton(element.name)"
                        style="font-weight: 500;">
                  {{ element.name }}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <section class="FT-all-funds watchlist-funds empty-watchlist pt-4">
    <div class="row align-items-center watchlist-box">
      <div class="col-lg-12">
        <div style="padding: 10px;" *ngIf="!isMobileAdd">
          <div class="filter-options mt-0 mb-4">
            <div class="d-flex">
              <div class="form-group ">
                <input type="text" class="form-control search"
                       placeholder="{{ 'products.compare-fund-search-placeholder' | translate }}"
                       [(ngModel)]="searchTerm" (input)="searchFunds(searchTerm)">
                <div class="search-result cust-color"
                     *ngIf="showFundSearchDropdown && searchTerm && searchTerm.length >= 3">
                  <div class="inner">
                    <ng-container *ngFor="let fund of fundsForSearch">
                      <div class="funds-seach-title" (click)="showSelectedFund(fund)"
                           style="position: relative; z-index: 999999; cursor: pointer;">
                        <b>{{ fund?.fundName }}</b>
                        <span class="sub">{{ removeFundString(fund?.assetClass) }}</span>
                        <span class="sub">{{ removeFundString(fund?.invfocus) }}</span>
                        <span class="sub">{{ fund?.fundInceptionDate | yearsOld }}</span>

                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
              <div>
                <img alt="Close" class="share-icon2" src="./assets/images/comparefund/closebutton.svg"
                     class="make-tag-for-all-page"
                     (click)="clearSearch()">
              </div>
            </div>
            <div class="dataFilter">
              <div class="d-flex align-items-center">
                <span class="me-2">{{ "products.all-funds-sort-by-btn" | translate }}</span>
                <div class="dropdown">
                  <button class="btn dropdown-toggle" type="button" data-bs-toggle="dropdown"
                          aria-expanded="false">
                    <div class="has-filter-red-dot d-none"></div>
                    <span class="sort-by-text">{{ selectedSortItem.label }}</span>
                  </button>
                  <ul class="dropdown-menu">
                    <ng-container *ngFor="let item of sortItemsArray">
                      <li style="cursor: pointer;" (click)="sortFunds(item)"
                          [class.selected-option]="item.id === selectedSortItem.id">
                        <a class="dropdown-item">{{ item.label }}</a>
                      </li>
                    </ng-container>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-head mb-4 forwatclistnavtab">
            <div class="scrollable-tabs">
              <ul class="nav nav-tabs" id="myTab-add-fund" role="tablist" style="margin-bottom: 3px;">
                <li class="nav-item" role="presentation" *ngFor="let element of sideFilterOptions; let i = index">
                  <button class="nav-link"
                          [id]="element.name"
                          [ngClass]="{ 'active': element.name === activeButton }"
                          data-bs-toggle="pill"
                          data-bs-target="#v-pills-all-add-fund" type="button" role="tab"
                          [attr.aria-controls]="'v-pills-'+getMenuID(element.name, true)"
                          [attr.aria-selected]="{ true: i === 0 }"
                          [attr.data-tab-id]="'v-pills-'+getMenuID(element.name, true)"
                          (click)="showContentOnHover($event);setActiveButton(element.name)">{{ element.name }}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <ng-container *ngIf="fundData?.length">
          <div class="tab-content empty-page-card-list" id="v-pills-tabContent-add-fund"
               *ngIf="isLoaded && fundListingData?.length">
            <div class="tab-pane fade show active" id="v-pills-all-add-fund" role="tabpanel"
                 aria-labelledby="v-pills-all-tab" tabindex="0">
              <div class="funds-container" style="padding: 10px;">
                <ng-container *ngFor="let fund of fundListingData; let i = index;">
                  <ft-home-fund-card [fund]="fund" [cardType]="cardTypeData" [brConfiguration]="brConfiguration"
                                     [hasThreeDotOptions]="hasThreeDotOptions ? hasThreeDotOptions : false"></ft-home-fund-card>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </section>
</ng-container>
